import PatientDataTab from "./PatientDataTab";
export default PatientDataTab;
